// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1w9RW","head":"ProcedureTableInfo_head__2Jg3o"};